




import { Component, Vue, Watch } from "vue-property-decorator";

@Component
class LegalRiskTerms extends Vue {
  content = require("../../assets/docs/legal_risk_en.md");

  @Watch("$i18n.locale", { immediate: true })
  updateContent() {
    const locale = this.$i18n.locale;
    this.content = require(`../../assets/docs/legal_risk_${locale}.md`);
  }
}
export default LegalRiskTerms;
